import { render, staticRenderFns } from "./Epic.vue?vue&type=template&id=c159090a&scoped=true&"
import script from "./Epic.vue?vue&type=script&lang=js&"
export * from "./Epic.vue?vue&type=script&lang=js&"
import style0 from "./Epic.vue?vue&type=style&index=0&id=c159090a&scoped=true&lang=css&"
import style1 from "./Epic.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c159090a",
  null
  
)

export default component.exports